import { render } from "./CardMonitoringAddDialog.vue?vue&type=template&id=f8f6c462&ts=true"
import script from "./CardMonitoringAddDialog.vue?vue&type=script&lang=ts"
export * from "./CardMonitoringAddDialog.vue?vue&type=script&lang=ts"

import "./CardMonitoringAddDialog.vue?vue&type=style&index=0&id=f8f6c462&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__